import React from "react";
import styles from "./ImageBlock.module.css";
import DeleteButton from "../../../reusable/Button/DeleteButton";

export default function ImageBlock(props) {
	return (
		<div className={styles.imageBlock}>
			<div className={styles.deleteBtn}>
				<DeleteButton action={() => props.onDelete()} />
			</div>
			<img className={styles.image} src={props.src} alt="" />
		</div>
	);
}
